import { GET_TEMPLATES } from '../actions/types';

export default function templatesReducer(state = [], action) {
	switch (action.type) {
		case GET_TEMPLATES:
			return action.payload.templates || [];
		default:
			return state;
	}
}
